// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d8cbada","239":"f671d85b","453":"8faa970c","732":"e34248fa"}[chunkId] + ".chunk.js";
};